import MCallingPendingAgents from './index.vue';

MCallingPendingAgents.install = app => {
  app.component(MCallingPendingAgents.name, MCallingPendingAgents);
};

export default MCallingPendingAgents;
